import { VENDOR_DOWNLOAD_DUMP, VENDOR_DOWNLOAD_DUMP_SUCCESS, VENDOR_DOWNLOAD_DUMP_ERROR, VENDOR_DOWNLOAD_DUMP_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorDownloadDump = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_DOWNLOAD_DUMP:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_DOWNLOAD_DUMP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VENDOR_DOWNLOAD_DUMP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case VENDOR_DOWNLOAD_DUMP_EMPTY:
      state = {
        data: null,
        message: null,
        loading: false,
        success: false,
        error: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorDownloadDump;
